import service from './axios';
// Categories
export const getTrainingCategories = (params = {}) => service.get('/manage/training-categories', { params });
export const createTrainingCategory = (d) => service.post('/manage/training-categories', d);
export const updateTrainingCategory = (id, d) => service.put(`/manage/training-categories/${id}`, d);
export const deleteTrainingCategory = (id) => service.delete(`/manage/training-categories/${id}`);
export const updateTrainingQrCode = (url) => service.put('/manage/training-categories/qrcode', { qrcode_url: url });
// Contents
export const getTrainingContents = (params = {}) => service.get('/manage/training-contents', { params });
export const getTrainingContent = (id) => service.get(`/manage/training-contents/${id}`);
export const createTrainingContent = (d) => service.post('/manage/training-contents', d);
export const updateTrainingContent = (id, d) => service.put(`/manage/training-contents/${id}`, d);
export const deleteTrainingContent = (id) => service.delete(`/manage/training-contents/${id}`);
